// extracted by mini-css-extract-plugin
module.exports = {"version":"SideBar_version__18xel"};